import { render, staticRenderFns } from "./ProgramCardExpanded.vue?vue&type=template&id=15330714&"
import script from "./ProgramCardExpanded.vue?vue&type=script&lang=js&"
export * from "./ProgramCardExpanded.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCardExpanded.vue?vue&type=style&index=0&id=15330714&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports